<template>
  <nav class="breadcrumb">
    <ul>
      <li v-for="link in links">
        <router-link :to='link.url'>{{ link.name }}</router-link>
      </li>
     <li>{{protocol.title}}</li>
    </ul>
    
  </nav>
</template>

<script>
  export default {
    name: 'Breadcrumb',
    props: ['categories', 'protocol'],
    methods: {
      getProtocolCategories (protocol) {
        // Get the first key-value pair where key is category and
        // value is an array of subcategories
        const first = Object.entries(protocol['categories'])[0]
        const category = first[0]
        const subCategory = first[1][0]
        return [category, subCategory].filter((o) => o)
      }
    },
    computed: {
      myCategories () {
        let c = (this.categories || []).filter((o) => o)
        return c.length > 0 ? c : this.getProtocolCategories(this.protocol)
      },
      links () {
        let names = this.myCategories
        let url = '/categories/'
        let res = [{url: '/', name: 'Protocol Library'}]

        for (let name of names) {
          url += encodeURIComponent(name) + '/'
          res.push({ url, name })
        }

        return res
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Breadcrumb.vue?5ac7f378